import React from "react"
import { Link } from "react-router-dom"

const AccountLink = () => ( 
  <div className="menu-button">
    <Link className="account" to="/settings/account">Account</Link>
  </div>
)

export default AccountLink